"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toolbarTablePopoverDefaultProps = exports.toolbarTableModalDefaultProps = exports.toolbarTableEditModalDefaultProps = exports.toolbarLinkModalDefaultProps = exports.toolbarImageModalDefaultProps = exports.toolbarHighlightPopoverDefaultProps = exports.toolbarFontColorPopoverDefaultProps = exports.tableModalSharedLocalizationProps = exports.colorSharedLocalizationProps = exports.TOOLBAR_MODAL_WIDTH = exports.TOOLBAR_MODAL_TITLE_ID = exports.TOOLBAR_MODAL_CLOSE_TEXT_ID = exports.TOOLBAR_CONTROLS_BLOCK_PADDING_MOBILE = exports.TOOLBAR_CONTROLS_BLOCK_PADDING_DESKTOP = exports.HIGHLIGHT_DEFAULT_CLASS_NAME = exports.HIGHLIGHT_CLASS_NAME = exports.FOOTER_TEXT_FONT_SIZE = exports.FOOTER_TEXT_FONT_COLOR = exports.FONT_COLOR_DEFAULT_CLASS_NAME = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var TOOLBAR_MODAL_TITLE_ID = 'toolbar-modal-title';
exports.TOOLBAR_MODAL_TITLE_ID = TOOLBAR_MODAL_TITLE_ID;
var TOOLBAR_MODAL_CLOSE_TEXT_ID = 'toolbar-modal-close-dialog';
exports.TOOLBAR_MODAL_CLOSE_TEXT_ID = TOOLBAR_MODAL_CLOSE_TEXT_ID;
var TOOLBAR_MODAL_WIDTH = 512;
exports.TOOLBAR_MODAL_WIDTH = TOOLBAR_MODAL_WIDTH;
var TOOLBAR_CONTROLS_BLOCK_PADDING_DESKTOP = 16;
exports.TOOLBAR_CONTROLS_BLOCK_PADDING_DESKTOP = TOOLBAR_CONTROLS_BLOCK_PADDING_DESKTOP;
var TOOLBAR_CONTROLS_BLOCK_PADDING_MOBILE = 8;
exports.TOOLBAR_CONTROLS_BLOCK_PADDING_MOBILE = TOOLBAR_CONTROLS_BLOCK_PADDING_MOBILE;
var FOOTER_TEXT_FONT_SIZE = 'T100';
exports.FOOTER_TEXT_FONT_SIZE = FOOTER_TEXT_FONT_SIZE;
var FOOTER_TEXT_FONT_COLOR = 'neutral70';
exports.FOOTER_TEXT_FONT_COLOR = FOOTER_TEXT_FONT_COLOR;
var FONT_COLOR_DEFAULT_CLASS_NAME = 'ProseMirror-FontColor';
exports.FONT_COLOR_DEFAULT_CLASS_NAME = FONT_COLOR_DEFAULT_CLASS_NAME;
var HIGHLIGHT_CLASS_NAME = 'custom-highlight';
exports.HIGHLIGHT_CLASS_NAME = HIGHLIGHT_CLASS_NAME;
var HIGHLIGHT_DEFAULT_CLASS_NAME = 'ProseMirror-highlight';
exports.HIGHLIGHT_DEFAULT_CLASS_NAME = HIGHLIGHT_DEFAULT_CLASS_NAME;
var toolbarImageModalDefaultProps = {
  localization: {
    altDecorativeFooterInfo: 'Image is decorative, alt-text will only announce while editing.',
    altError: 'Image alt text must be provided',
    altPrompt: 'Image alt text',
    closeButtonAltText: 'Close image modal',
    closeDialogAltText: 'close dialog and move focus back into editor',
    decorativeCheckboxPrompt: 'Image is decorative',
    dimensionsTitleText: 'Image dimensions',
    heightPrompt: 'Image height',
    insertSubmitButtonText: 'Insert image',
    insertTitleText: 'Insert an image',
    retainProportionsCheckboxPrompt: 'Retain image proportions',
    srcPrompt: 'Link to image',
    srcError: 'Link to an image must be provided',
    toolbarButtonAddAltText: 'Add image',
    toolbarButtonEditAltText: 'Edit selected image',
    updateSubmitButtonText: 'Update image',
    updateTitleText: 'Update an image',
    widthPrompt: 'Image width'
  }
};
exports.toolbarImageModalDefaultProps = toolbarImageModalDefaultProps;
var toolbarLinkModalDefaultProps = {
  localization: {
    clearLinkButtonText: 'Clear link',
    closeButtonAltText: 'Close link modal',
    closeDialogAltText: 'close dialog and move focus back into editor',
    inputLabelText: 'Link to an existing web page',
    insertLinkButtonText: 'Insert link',
    modalTitleText: 'Insert, edit or clear link',
    toolbarButtonAddAltText: 'Add link',
    toolbarButtonEditAltText: 'Edit selected link'
  }
};
exports.toolbarLinkModalDefaultProps = toolbarLinkModalDefaultProps;
var toolbarTablePopoverDefaultProps = {
  localization: {
    createTableTitleText: 'Create a table',
    addRowTitleText: 'Add row below',
    addColumnTitleText: 'Add column after',
    removeRowTitleText: 'Remove selected row',
    removeColumnTitleText: 'Remove selected column',
    editTableTitleText: 'Accessibility properties',
    toggleHeaderColumnTitleText: 'Toggle column headers',
    toggleHeaderRowTitleText: 'Toggle row headers',
    toolbarButtonAddAltText: 'Add table',
    toolbarButtonEditAltText: 'Edit selected table'
  }
};
exports.toolbarTablePopoverDefaultProps = toolbarTablePopoverDefaultProps;
var tableModalSharedLocalizationProps = {
  modalDescriptionText: 'An alternative title represents the information presented in your table and is read aloud to a person with a disability using assistive devices.',
  cancelButtonText: 'Cancel',
  closeDialogAltText: 'and return to the editor',
  confirmButtonText: 'Confirm',
  confirmButtonAltText: 'Confirm',
  inputErrorAltTitleText: 'Your alternative title cannot be blank'
};
exports.tableModalSharedLocalizationProps = tableModalSharedLocalizationProps;
var toolbarTableModalDefaultProps = {
  localization: _objectSpread(_objectSpread({}, tableModalSharedLocalizationProps), {}, {
    createTableTitleText: 'Create a table',
    rowQuantityTitleText: 'Number of rows',
    columnQuantityText: 'Number of columns',
    altTitleText: 'Alt. title',
    accessibilityTitleText: 'Accessibility properties',
    closeDialogAltText: 'and return to the editor',
    inputErrorText: 'Number input is required',
    columnErrorOnlyNumbersText: 'Your table must have at least one column',
    rowErrorOnlyNumbersText: 'Your table must have at least one row',
    createTableErrorText: 'Error encountered when creating table. Try again.',
    dismissButtonAltText: 'Dismiss message banner and move focus back into the row input',
    messageBannerIconAltText: 'Error'
  })
};
exports.toolbarTableModalDefaultProps = toolbarTableModalDefaultProps;
var toolbarTableEditModalDefaultProps = {
  localization: _objectSpread(_objectSpread({}, tableModalSharedLocalizationProps), {}, {
    editTableTitleText: 'Accessibility properties',
    inputTitleText: 'Alt. title'
  })
};
exports.toolbarTableEditModalDefaultProps = toolbarTableEditModalDefaultProps;
var colorSharedLocalizationProps = {
  colorBlueTitleText: 'Blue',
  colorGreenTitleText: 'Green',
  colorPinkTitleText: 'Pink',
  colorPurpleTitleText: 'Purple',
  colorRedTitleText: 'Red',
  colorYellowTitleText: 'Yellow',
  colorWhiteTitleText: 'White',
  arialRoleHighlightText: 'highlight',
  arialRoleFontText: 'font',
  selectedText: 'selected'
};
exports.colorSharedLocalizationProps = colorSharedLocalizationProps;
var toolbarFontColorPopoverDefaultProps = {
  localization: _objectSpread(_objectSpread({}, colorSharedLocalizationProps), {}, {
    colorBlackTitleText: 'Black',
    fontColorTitleText: 'Applying text color removes applied highlight.'
  })
};
exports.toolbarFontColorPopoverDefaultProps = toolbarFontColorPopoverDefaultProps;
var toolbarHighlightPopoverDefaultProps = {
  localization: _objectSpread(_objectSpread({}, colorSharedLocalizationProps), {}, {
    noHighlightText: 'No highlight',
    highlightTitleText: 'Applying highlight removes applied text color.'
  })
};
exports.toolbarHighlightPopoverDefaultProps = toolbarHighlightPopoverDefaultProps;